module.exports = __webpack_public_path__ + "static/follow-a615e7d40db54d1e98ea84dcf203141d.svg";